import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
    getConsultationRequestBySenderId,
    getConsultationRequestByReceiverId,
    getConsultationRequestBySenderIdOrReceiverId,
    postConsultationRequest,
    getConsultationRequestAllPage,
    updateConsultationRequest,
    deleteConsultationRequest,
    getConsultationRequestById

} from "./consultationRequestService";

import {
    getMessageByConsultationRequestId,
    postMessage,
    updateMessage,
    deleteMessage,
    uploadFileToMessage,
    downloadFileFromMessage
} from "../../services/messageService";

import {
    getAllConsultantPage,
    getLoggedInUser,
    hasRole,
    isUserLoggedIn
} from "../../pages/userapp/ServiceUserApp";

import {
    getSpecialiteByNatureActivityType
} from "../../pages/specialite/ServiceSpecialite";

import {
    getActivityProfByTypeActivityPro
} from "../../pages/activityprof/ServiceActivityProf";

import {
    getAllWilaya
} from "../../pages/wilaya/ServiceWilaya";

import ConsultationSearchBar from "./ConsultationSearchBar";
import ConsultationRequestList from "./ConsultationRequestList";
import ConsultationRequestForm from "./ConsultationRequestForm";
import ConsultationRequestDetail from "./ConsultationRequestDetail";
import Pagination from "../../common/Pagination";
import ConfirmationModal from "../../components/home/ConfirmationModal";
import "../../styles/ConsultationRequest.css";


/* ============================================================
   OBJETS VIDES
   ============================================================ */

const emptyConsultation = {
    id: null,
    consultationObject: "",
    consultationBody: "",
    consultationType: "L",
    sender: {},
    receiver: {}
};

const emptyMessage = {
    messageBody: "",
    attachedFile1: null,
    attachedFile2: null,
    attachedFile3: null,
    attachedFile4: null
};


/* ============================================================
   COMPOSANT
   ============================================================ */

export default function ConsultationRequestPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    /* ========================================================
       UTILISATEUR CONNECTÉ
       ======================================================== */

    const connected = isUserLoggedIn();
    const loggedUser = getLoggedInUser();
    const isAuthenticated = !!loggedUser;


    /*
     * ADMIN uniquement si utilisateur connecté
     */
    const isAdmin =
        isAuthenticated &&
        hasRole("ADMIN_ROLE");

const userType = loggedUser?.falahOrProf;

// F = Fellah
// P = Professionnel
const canSendConsultation =
    userType === "F" || userType === "P";

    const [keyword2, setKeyword2] = useState("");

    const [consultationFilter, setConsultationFilter] =
    useState("ALL");

    const [consultations, setConsultations] =
        useState([]);

    const [message, setMessage] =
        useState(emptyMessage);

    const [messages, setMessages] =
        useState([]);

    const [consultants, setConsultants] =
        useState([]);

    const [consultation, setConsultation] =
        useState(emptyConsultation);

    const [specialites, setSpecialites] =
        useState([]);

    const [activityProfs, setActivityProfs] =
        useState([]);

    const [wilayas, setWilayas] =
        useState([]);

    const [errors, setErrors] =
        useState({});

    const [loading, setLoading] =
        useState(false);

    const [saving, setSaving] =
        useState(false);

    const [keyword, setKeyword] =
        useState("");

    const [page, setPage] =
        useState(0);

    const [size] =
        useState(10);

    const [totalPages, setTotalPages] =
        useState(0);

    const [showForm, setShowForm] =
        useState(false);

    const [showDetail, setShowDetail] =
        useState(false);


    /* ========================================================
       FILTRES CONSULTANTS
       ======================================================== */

    const [consultantFilters, setConsultantFilters] =
        useState({
            idActivityProf: "",
            idSpecialite: "",
            idWilaya: ""
        });


    /* ========================================================
       SUPPRESSION
       ======================================================== */

    const [deleteConsultationId, setDeleteConsultationId] =
        useState(null);

    const [showConfirmationModal, setShowConfirmationModal] =
        useState(false);


    /* ========================================================
       REDIRECTION LOGIN
       ======================================================== */

    const redirectToLogin = () => {

        navigate("/login", {
            replace: true
        });
    };


    /* ========================================================
       REDIRECTION SI UTILISATEUR NON CONNECTÉ
       ======================================================== */

    useEffect(() => {

        if (!isAuthenticated) {

            redirectToLogin();
        }

    }, [
        isAuthenticated
    ]);


    /* ========================================================
       ANNULATION FORMULAIRE
       ======================================================== */

    const handleCancel = () => {

        setShowForm(false);

        setConsultation({
            ...emptyConsultation
        });

        setMessage({
            ...emptyMessage
        });

        setErrors({});

        setConsultantFilters({
            idActivityProf: "",
            idSpecialite: "",
            idWilaya: ""
        });

        setConsultants([]);
    };


    /* ========================================================
       CHARGEMENT DES FILTRES
       ======================================================== */

    const loadFilters = async () => {

        /*
         * Sécurité
         */
        if (!isAuthenticated) {
            return;
        }


        /* ----------------------------------------------------
           Spécialités
           ---------------------------------------------------- */

        try {

            await getSpecialiteByNatureActivityType("");

        }
        catch (error) {

            console.error(
                "Erreur chargement spécialités :",
                error
            );
        }


        /* ----------------------------------------------------
           Activités professionnelles
           ---------------------------------------------------- */

        try {

            await getActivityProfByTypeActivityPro("");

        }
        catch (error) {

            console.error(
                "Erreur chargement activités professionnelles :",
                error
            );
        }


        /* ----------------------------------------------------
           Wilaya
           ---------------------------------------------------- */

        try {

            await getAllWilaya(
                "",
                ["wilaya"],
                "ASC"
            );

        }
        catch (error) {

            console.error(
                "Erreur chargement wilayas :",
                error
            );
        }
    };


    /* ========================================================
       CHARGEMENT WILAYAS
       ======================================================== */

    const loadWilayas = async () => {

        if (!isAuthenticated) {
            return;
        }

        try {

            const response =
                await getAllWilaya(
                    "",
                    ["id"],
                    "ASC"
                );

            setWilayas(
                response?.data ?? []
            );

        }
        catch (error) {

            console.error(
                "Erreur chargement wilayas :",
                error
            );

            setWilayas([]);
        }
    };


/* ========================================================
   CHARGEMENT CONSULTATIONS
   ======================================================== */

const loadConsultations = async () => {

    if (!isAuthenticated || !loggedUser?.id) {
        return;
    }

    setLoading(true);

    try {

        let response;
        // ============================================================
        // ADMIN : toutes les consultations
        // ============================================================
        if (isAdmin) {
            response = await getConsultationRequestAllPage(
                keyword,
                page,
                size,
                ["id"],
                "DESC"
            );
        }

        // ============================================================
        // TOUTES : sender OU receiver
        // ============================================================

        else if (consultationFilter === "ALL") {
            response = await getConsultationRequestBySenderIdOrReceiverId(
                loggedUser.id,
                loggedUser.id,
                keyword,
                0.60,
                page,
                size,
                ["id"],
                "DESC"
            );
        }
        // ============================================================
        // REÇUES : receiver
        // ============================================================
        else if (consultationFilter === "RECEIVED") {
            response = await getConsultationRequestByReceiverId(
                loggedUser.id,
                keyword,
                0.60,
                page,
                size,
                ["id"],
                "DESC"
            );
        }
        // ============================================================
        // ÉMISES : sender
        // ============================================================

        else if (consultationFilter === "SENT") {
            response = await getConsultationRequestBySenderId(
                loggedUser.id,
                keyword,
                0.60,
                page,
                size,
                ["id"],
                "DESC"
            );
        }

        // ============================================================
        // SÉCURITÉ
        // ============================================================

        if (!response) {
            setConsultations([]);
            setTotalPages(0);
            return;
        }

        console.log(
            "========== CONSULTATIONS =========="
        );

        console.log(
            "Filter :",
            consultationFilter
        );

        console.log(
            "User ID :",
            loggedUser.id
        );

        console.log(
            "Response :",
            response
        );

        console.log(
            "Response.data :",
            response.data
        );

        // ============================================================
        // RÉSULTAT PAGINÉ
        // ============================================================

        const data = response.data;

        const content = Array.isArray(data?.content)
            ? data.content
            : [];

        const pages = Number(data?.totalPages ?? 0);

        setConsultations(content);
        setTotalPages(pages);

    }
    catch (error) {

        console.error(
            "========== ERREUR CHARGEMENT CONSULTATIONS =========="
        );

        console.error(
            "Erreur complète :",
            error
        );

        if (error.response) {

            console.error(
                "Status :",
                error.response.status
            );

            console.error(
                "Body :",
                error.response.data
            );

        }
        else {

            console.error(
                "Message :",
                error.message
            );
        }

        setConsultations([]);
        setTotalPages(0);

    }
    finally {

        setLoading(false);
    }
};

    /* ========================================================
       EFFECT CHARGEMENT CONSULTATIONS
       ======================================================== */

useEffect(() => {
    if (!isAuthenticated) {
        return;
    }
    loadConsultations();

}, [
    page,
    keyword,
    consultationFilter,
    isAuthenticated
]);

    /* ========================================================
       EFFECT CHARGEMENT FILTRES
       ======================================================== */
    useEffect(() => {

        if (!isAuthenticated) {
            return;
        }
        loadFilters();
        loadWilayas();
    }, [
        isAuthenticated
    ]);
    /* ========================================================
       CHARGEMENT CONSULTANTS
       ======================================================== */
    const loadConsultants = async (
        consultationType = consultation.consultationType
    ) => {

        if (!isAuthenticated) {
            return;
        }
        try {
            const response =
                await getAllConsultantPage(
                    "",
                    0.6,
                    consultationType,
                    consultantFilters.idSpecialite
                        ? [
                            consultantFilters.idSpecialite
                        ]
                        : [],

                    consultantFilters.idActivityProf
                        ? [
                            consultantFilters.idActivityProf
                        ]
                        : [],

                    consultantFilters.idWilaya,

                    0,
                    50,

                    ["fullName"],
                    "ASC"
                );
            setConsultants(
                response?.data?.content ?? []
            );
        }
        catch (error) {

            console.error(
                "Erreur chargement consultants :",
                error
            );

            setConsultants([]);
        }
    };


    /* ========================================================
       EFFECT CHARGEMENT CONSULTANTS
       ======================================================== */

    useEffect(() => {

        if (!isAuthenticated) {
            return;
        }

        if (!showForm) {
            return;
        }

        loadConsultants();

    }, [
        consultantFilters.idActivityProf,
        consultantFilters.idSpecialite,
        consultantFilters.idWilaya,
        isAuthenticated,
        showForm
    ]);

    /* ========================================================
       TITRE PAGE
       ======================================================== */
const pageTitle =
    consultationFilter === "RECEIVED"
        ? t("consultationRequest.pageTitleReceiver")
        : consultationFilter === "SENT"
            ? t("consultationRequest.pageTitleSender")
            : t("consultationRequest.pageTitleAll");

    /* ========================================================
       RECHERCHE
       ======================================================== */

    const handleSearch = (value) => {
        setPage(0);
        setKeyword(value);
    };

    /* ========================================================
       AJOUT CONSULTATION
       ======================================================== */

    const handleAdd = async () => {
        if (!isAuthenticated) {
            redirectToLogin();
            return;
        }

        /* ----------------------------------------------------
           Réinitialisation
           ---------------------------------------------------- */
        setConsultation({
            ...emptyConsultation
        });

        setMessage({
            ...emptyMessage
        });

        setErrors({});


        setConsultantFilters({
            idActivityProf: "",
            idSpecialite: "",
            idWilaya: ""
        });

        /* ----------------------------------------------------
           Wilaya
           ---------------------------------------------------- */
        await loadWilayas();

        /* ----------------------------------------------------
           Activités professionnelles
           ---------------------------------------------------- */
        try {
            const responseActivityProf =
                await getActivityProfByTypeActivityPro(
                    "L"
                );
            setActivityProfs(
                responseActivityProf?.data ?? []
            );
        }
        catch (error) {

            console.error(
                "Erreur activités professionnelles :",
                error
            );

            setActivityProfs([]);
        }
        /* ----------------------------------------------------
           Spécialités
           ---------------------------------------------------- */

        try {

            const responseSpecialite =
                await getSpecialiteByNatureActivityType(
                    "L"
                );

            setSpecialites(
                responseSpecialite?.data ?? []
            );

        }
        catch (error) {

            console.error(
                "Erreur spécialités :",
                error
            );

            setSpecialites([]);
        }


        /* ----------------------------------------------------
           Consultants
           ---------------------------------------------------- */

        await loadConsultants("L");


        /* ----------------------------------------------------
           Affichage formulaire
           ---------------------------------------------------- */

        setShowForm(true);
    };


    /* ========================================================
       FILTRE CONSULTANT
       ======================================================== */

    const handleConsultantFilterChange = (e) => {

        const {
            name,
            value
        } = e.target;


        setConsultantFilters(
            prev => ({
                ...prev,
                [name]: value
            })
        );
    };


    /* ========================================================
       CHARGEMENT MESSAGES
       ======================================================== */

    const loadMessages = async (
        consultationId
    ) => {

        if (!isAuthenticated) {
            return;
        }

        if (!consultationId) {
            return;
        }

        try {

            const response =
                await getMessageByConsultationRequestId(
                    consultationId
                );


            setMessages(
                response?.data ?? []
            );

        }
        catch (error) {

            console.error(
                "Erreur chargement messages :",
                error
            );

            setMessages([]);
        }
    };


    /* ========================================================
       TÉLÉCHARGEMENT FICHIER
       ======================================================== */

    const handleDownloadFile = async (
        messageId,
        index
    ) => {

        if (!isAuthenticated) {

            redirectToLogin();

            return;
        }


        try {

            const response =
                await downloadFileFromMessage(
                    messageId,
                    index
                );


            /* ------------------------------------------------
               Nom fichier
               ------------------------------------------------ */

            let filename = "document";


            const disposition =
                response.headers[
                    "content-disposition"
                ];


            if (disposition) {

                const match =
                    disposition.match(
                        /filename="?([^"]+)"?/
                    );


                if (match) {

                    filename =
                        match[1];
                }
            }


            /* ------------------------------------------------
               Blob
               ------------------------------------------------ */

            const blob =
                new Blob(
                    [response.data],
                    {
                        type:
                            response.headers[
                                "content-type"
                            ]
                    }
                );


            /* ------------------------------------------------
               URL
               ------------------------------------------------ */

            const url =
                window.URL.createObjectURL(
                    blob
                );


            /* ------------------------------------------------
               Lien téléchargement
               ------------------------------------------------ */

            const link =
                document.createElement("a");


            link.href = url;

            link.download = filename;


            document.body.appendChild(
                link
            );


            link.click();


            link.remove();


            window.URL.revokeObjectURL(
                url
            );

        }
        catch (error) {

            console.error(
                "Erreur téléchargement fichier :",
                error
            );
        }
    };


    /* ========================================================
       RÉPONDRE À UNE CONSULTATION
       ======================================================== */

    const handleReply = async (e) => {

        e.preventDefault();


        /* ----------------------------------------------------
           Vérification connexion
           ---------------------------------------------------- */

        if (!isAuthenticated || !loggedUser) {

            redirectToLogin();

            return;
        }


        /* ----------------------------------------------------
           Validation
           ---------------------------------------------------- */

        const validationErrors = {};


        if (
            !message.messageBody ||
            message.messageBody.trim() === ""
        ) {

            validationErrors.messageBody =
                t(
                    "validation.requiredMessage"
                );
        }


        setErrors(
            validationErrors
        );


        if (
            Object.keys(
                validationErrors
            ).length > 0
        ) {

            return;
        }


        /* ----------------------------------------------------
           Vérification consultation
           ---------------------------------------------------- */

        if (!consultation?.id) {

            console.error(
                "Consultation invalide."
            );

            return;
        }


        if (!consultation?.receiver?.id) {

            console.error(
                "Destinataire de la consultation introuvable."
            );

            return;
        }


        /* ----------------------------------------------------
           DTO message
           ---------------------------------------------------- */

        const messageDto = {

            consultationRequest: {
                id: consultation.id
            },

            sender: {
                id: loggedUser.id
            },

            receiver: {
                id: consultation.receiver.id
            },

            messageObject:
                consultation.consultationObject,

            messageBody:
                message.messageBody.trim()
        };


        try {

            setSaving(true);


            /* ------------------------------------------------
               Enregistrement message
               ------------------------------------------------ */

            const response =
                await postMessage(
                    messageDto
                );


            const saved =
                response.data;


            /* ------------------------------------------------
               Fichiers
               ------------------------------------------------ */

            const files = [

                message.attachedFile1,
                message.attachedFile2,
                message.attachedFile3,
                message.attachedFile4

            ];


            for (
                let i = 0;
                i < files.length;
                i++
            ) {

                if (files[i]) {

                    const formData =
                        new FormData();


                    formData.append(
                        "file",
                        files[i]
                    );


                    await uploadFileToMessage(
                        saved.id,
                        i + 1,
                        formData
                    );
                }
            }


            /* ------------------------------------------------
               Rafraîchir messages
               ------------------------------------------------ */

            await loadMessages(
                consultation.id
            );


            /* ------------------------------------------------
               Réinitialisation
               ------------------------------------------------ */

            setMessage({
                ...emptyMessage
            });

            setErrors({});

        }
        catch (error) {

            console.error(
                "Erreur réponse consultation :",
                error
            );

            if (error.response) {

                console.error(
                    "Status :",
                    error.response.status
                );

                console.error(
                    "Body :",
                    error.response.data
                );
            }

        }
        finally {

            setSaving(false);
        }
    };


    /* ========================================================
       MODIFIER CONSULTATION
       ======================================================== */

    const handleEdit = async (
        item
    ) => {

        if (!isAuthenticated) {

            redirectToLogin();

            return;
        }


        if (!item?.id) {

            console.error(
                "Impossible de modifier la consultation : ID absent."
            );

            return;
        }


        try {

            /* ------------------------------------------------
               Consultation
               ------------------------------------------------ */

            const consultationResponse =
                await getConsultationRequestById(
                    item.id
                );


            setConsultation(
                consultationResponse.data
            );


            /* ------------------------------------------------
               Messages
               ------------------------------------------------ */

            const response =
                await getMessageByConsultationRequestId(
                    item.id
                );


            if (
                response?.data?.length > 0
            ) {

                setMessage(
                    response.data[0]
                );

            }
            else {

                setMessage({
                    ...emptyMessage,
                    messageObject:
                        consultationResponse
                            .data
                            .consultationObject
                });
            }


            /* ------------------------------------------------
               Chargement des filtres selon le type
               ------------------------------------------------ */

            const consultationType =
                consultationResponse
                    ?.data
                    ?.consultationType ?? "L";


            try {

                const responseActivityProf =
                    await getActivityProfByTypeActivityPro(
                        consultationType
                    );


                setActivityProfs(
                    responseActivityProf?.data ?? []
                );

            }
            catch (error) {

                console.error(
                    "Erreur chargement activités :",
                    error
                );

                setActivityProfs([]);
            }


            try {

                const responseSpecialite =
                    await getSpecialiteByNatureActivityType(
                        consultationType
                    );


                setSpecialites(
                    responseSpecialite?.data ?? []
                );

            }
            catch (error) {

                console.error(
                    "Erreur chargement spécialités :",
                    error
                );

                setSpecialites([]);
            }


            await loadWilayas();

            await loadConsultants(
                consultationType
            );


            setShowDetail(false);

            setShowForm(true);

        }
        catch (error) {

            console.error(
                "Erreur modification consultation :",
                error
            );
        }
    };


    /* ========================================================
       DÉTAIL CONSULTATION
       ======================================================== */

    const handleDetail = async (
        item
    ) => {

        if (!isAuthenticated) {

            redirectToLogin();

            return;
        }


        if (!item?.id) {

            console.error(
                "Impossible d'afficher le détail : ID absent."
            );

            return;
        }


        try {

            /* ------------------------------------------------
               Consultation complète
               ------------------------------------------------ */

            const consultationResponse =
                await getConsultationRequestById(
                    item.id
                );


            setConsultation(
                consultationResponse.data
            );


            /* ------------------------------------------------
               Messages
               ------------------------------------------------ */

            const messagesResponse =
                await getMessageByConsultationRequestId(
                    item.id
                );


            setMessages(
                messagesResponse?.data ?? []
            );


            /* ------------------------------------------------
               Composeur
               ------------------------------------------------ */

            setMessage({
                ...emptyMessage,
                messageObject:
                    consultationResponse
                        ?.data
                        ?.consultationObject ?? ""
            });


            setErrors({});

            setShowForm(false);

            setShowDetail(true);

        }
        catch (error) {

            console.error(
                "Erreur détail consultation :",
                error
            );

            setMessages([]);
        }
    };


    /* ========================================================
       SÉLECTION CONSULTATION À SUPPRIMER
       ======================================================== */

    const handleDelete = (
        id
    ) => {

        /* ----------------------------------------------------
           Utilisateur non connecté
           ---------------------------------------------------- */

        if (!isAuthenticated) {

            redirectToLogin();

            return;
        }


        /* ----------------------------------------------------
           Vérification ID
           ---------------------------------------------------- */

        if (!id) {

            console.error(
                "Impossible de supprimer la consultation : ID absent."
            );

            return;
        }


        /* ----------------------------------------------------
           Mémoriser ID
           ---------------------------------------------------- */

        setDeleteConsultationId(id);


        /* ----------------------------------------------------
           Afficher modal
           ---------------------------------------------------- */

        setShowConfirmationModal(
            true
        );
    };


    /* ========================================================
       FERMER MODAL SUPPRESSION
       ======================================================== */

    const handleCloseModal = () => {

        setShowConfirmationModal(
            false
        );

        setDeleteConsultationId(
            null
        );
    };


    /* ========================================================
       CONFIRMER SUPPRESSION
       ======================================================== */

    const handleConfirmDelete = async () => {

        /* ----------------------------------------------------
           Vérification ID
           ---------------------------------------------------- */

        if (!deleteConsultationId) {

            console.error(
                "Impossible de supprimer la consultation : ID absent."
            );

            handleCloseModal();

            return;
        }


        /* ----------------------------------------------------
           Vérification connexion
           ---------------------------------------------------- */

        if (!isAuthenticated) {

            handleCloseModal();

            redirectToLogin();

            return;
        }


        try {

            /* ------------------------------------------------
               Suppression backend
               ------------------------------------------------ */

            await deleteConsultationRequest(
                deleteConsultationId
            );


            /* ------------------------------------------------
               Fermer modal
               ------------------------------------------------ */

            setShowConfirmationModal(
                false
            );

            setDeleteConsultationId(
                null
            );


            /* ------------------------------------------------
               Rafraîchir liste
               ------------------------------------------------ */

            await loadConsultations();

        }
        catch (error) {

            console.error(
                "Erreur lors de la suppression de la consultation :",
                error
            );


            if (error.response) {

                console.error(
                    "Status :",
                    error.response.status
                );

                console.error(
                    "Body :",
                    error.response.data
                );
            }


            /* ------------------------------------------------
               Fermer modal même en cas d'erreur
               ------------------------------------------------ */

            setShowConfirmationModal(
                false
            );

            setDeleteConsultationId(
                null
            );
        }
    };


    /* ========================================================
       CHANGEMENT FORMULAIRE
       ======================================================== */

    const handleChange = async (e) => {

        const {
            name,
            value,
            files,
            type
        } = e.target;


        /* ----------------------------------------------------
           FICHIER
           ---------------------------------------------------- */

        if (type === "file") {

            setMessage(
                prev => ({
                    ...prev,
                    [name]:
                        files?.[0] ?? null
                })
            );

            return;
        }


        /* ----------------------------------------------------
           TYPE CONSULTATION
           ---------------------------------------------------- */

        if (
            name === "consultationType"
        ) {

            try {

                /* --------------------------------------------
                   Activités professionnelles
                   -------------------------------------------- */

                const responseActivityProf =
                    await getActivityProfByTypeActivityPro(
                        value
                    );


                setActivityProfs(
                    responseActivityProf?.data ?? []
                );


                /* --------------------------------------------
                   Spécialités
                   -------------------------------------------- */

                const responseSpecialite =
                    await getSpecialiteByNatureActivityType(
                        value
                    );


                setSpecialites(
                    responseSpecialite?.data ?? []
                );


                /* --------------------------------------------
                   Réinitialisation filtres
                   -------------------------------------------- */

                setConsultantFilters({
                    idActivityProf: "",
                    idSpecialite: "",
                    idWilaya: ""
                });


                /* --------------------------------------------
                   Réinitialisation destinataire
                   -------------------------------------------- */

                setConsultation(
                    prev => ({
                        ...prev,
                        consultationType:
                            value,
                        receiver: {}
                    })
                );


                /* --------------------------------------------
                   Rechargement consultants
                   -------------------------------------------- */

                await loadConsultants(
                    value
                );

            }
            catch (error) {

                console.error(
                    "Erreur changement type consultation :",
                    error
                );
            }

            return;
        }


        /* ----------------------------------------------------
           CONSULTANT
           ---------------------------------------------------- */

        if (
            name === "receiver"
        ) {

            setConsultation(
                prev => ({
                    ...prev,
                    receiver: value
                })
            );

            return;
        }


        /* ----------------------------------------------------
           OBJET CONSULTATION
           ---------------------------------------------------- */

        if (
            name === "consultationObject"
        ) {

            setConsultation(
                prev => ({
                    ...prev,
                    consultationObject:
                        value
                })
            );

            return;
        }


        /* ----------------------------------------------------
           MESSAGE
           ---------------------------------------------------- */

        setMessage(
            prev => ({
                ...prev,
                [name]: value
            })
        );
    };


    /* ========================================================
       VALIDATION
       ======================================================== */

    const validateForm = () => {

        const validationErrors = {};


        /* ----------------------------------------------------
           Consultant
           ---------------------------------------------------- */

        if (
            !consultation.receiver?.id
        ) {

            validationErrors.receiver =
                t(
                    "validation.receiverRequired"
                );
        }


        /* ----------------------------------------------------
           Objet
           ---------------------------------------------------- */

        if (
            !consultation.consultationObject ||
            consultation.consultationObject.trim() === ""
        ) {

            validationErrors.consultationObject =
                t(
                    "validation.consultationObjectRequired"
                );
        }


        /* ----------------------------------------------------
           Message
           ---------------------------------------------------- */

        if (
            !message.messageBody ||
            message.messageBody.trim() === ""
        ) {

            validationErrors.messageBody =
                t(
                    "validation.requiredMessage"
                );
        }


        /* ----------------------------------------------------
           Enregistrement erreurs
           ---------------------------------------------------- */

        setErrors(
            validationErrors
        );


        return (
            Object.keys(
                validationErrors
            ).length === 0
        );
    };


    /* ========================================================
       SAUVEGARDE CONSULTATION
       ======================================================== */

    const handleSubmit = async (e) => {

        e.preventDefault();


        /* ----------------------------------------------------
            {t("connexion.login")}
           ---------------------------------------------------- */

        if (!isAuthenticated || !loggedUser) {

            redirectToLogin();

            return;
        }


        /* ----------------------------------------------------
           Validation
           ---------------------------------------------------- */

        if (!validateForm()) {
            return;
        }


        setSaving(true);


        try {

            /* ------------------------------------------------
               DTO consultation
               ------------------------------------------------ */

            const consultationDto = {

                ...consultation,

                sender: {
                    id: loggedUser.id
                },

                receiver: {
                    id:
                        consultation
                            .receiver
                            .id
                }
            };


            let consultationSaved;


            /* ------------------------------------------------
               CRÉATION
               ------------------------------------------------ */

            if (
                consultationDto.id == null
            ) {

                const response =
                    await postConsultationRequest(
                        consultationDto
                    );


                consultationSaved =
                    response.data;
            }


            /* ------------------------------------------------
               MODIFICATION
               ------------------------------------------------ */

            else {

                const response =
                    await updateConsultationRequest(
                        consultationDto
                    );


                consultationSaved =
                    response.data;
            }


            /* ------------------------------------------------
               Vérification résultat
               ------------------------------------------------ */

            if (!consultationSaved?.id) {

                throw new Error(
                    "La consultation n'a pas été correctement enregistrée."
                );
            }


            /* ------------------------------------------------
               DESTINATAIRE MESSAGE
               ------------------------------------------------ */

            const receiverId =
                consultationSaved
                    .sender
                    .id ===
                loggedUser.id

                    ? consultationSaved
                        .receiver
                        .id

                    : consultationSaved
                        .sender
                        .id;


            /* ------------------------------------------------
               PREMIER MESSAGE
               ------------------------------------------------ */

            const messageDto = {

                consultationRequest: {
                    id:
                        consultationSaved.id
                },

                sender: {
                    id:
                        loggedUser.id
                },

                receiver: {
                    id:
                        receiverId
                },

                messageObject:
                    consultationSaved
                        .consultationObject,

                messageBody:
                    message.messageBody
            };


            const responseMessage =
                await postMessage(
                    messageDto
                );


            const messageSaved =
                responseMessage.data;


            /* ------------------------------------------------
               UPLOAD PIÈCES JOINTES
               ------------------------------------------------ */

            const files = [

                message.attachedFile1,
                message.attachedFile2,
                message.attachedFile3,
                message.attachedFile4

            ];


            for (
                let i = 0;
                i < files.length;
                i++
            ) {

                if (files[i]) {

                    const formData =
                        new FormData();


                    formData.append(
                        "file",
                        files[i]
                    );


                    await uploadFileToMessage(

                        messageSaved.id,

                        i + 1,

                        formData

                    );
                }
            }


            /* ------------------------------------------------
               RAFRAÎCHISSEMENT
               ------------------------------------------------ */

            await loadConsultations();


            /* ------------------------------------------------
               RÉINITIALISATION
               ------------------------------------------------ */

            setConsultation({
                ...emptyConsultation
            });

            setMessage({
                ...emptyMessage
            });

            setErrors({});

            setShowForm(false);

        }
        catch (error) {

            console.error(
                "Erreur enregistrement consultation :",
                error
            );


            if (error.response) {

                console.error(
                    "Status :",
                    error.response.status
                );

                console.error(
                    "Body :",
                    error.response.data
                );


                alert(
                    error.response.data?.message ??
                    "Erreur lors de l'enregistrement."
                );

            }
            else {

                alert(
                    error.message ??
                    "Une erreur est survenue."
                );
            }

        }
        finally {

            setSaving(false);
        }
    };

    if (!isAuthenticated) {
        return null;
    }


    return (
        <div className="container-fluid consultation-page py-3">
            {/* ==================================================
                CARTE PRINCIPALE
               ================================================== */}
            <div className="card shadow-sm border-0">
                {/* ==================================================
                    HEADER
                   ================================================== */}
                <div className="card-header bg-success text-white">
                    <div
                        className="
                            d-flex
                            justify-content-between
                            align-items-center
                        "
                    >
                        <h4 className="mb-0">
                            <i className="bi bi-chat-dots me-2"></i>
                            {pageTitle}
                        </h4>
                        {/* ------------------------------------------------
                            NOUVELLE CONSULTATION
                           ------------------------------------------------ */}
   {canSendConsultation && (
    <button
        type="button"
        className="btn btn-light"
        onClick={handleAdd}
    >
        <i className="bi bi-plus-circle me-2"></i>
        {t("button.create")}
    </button>
)}

                    </div>

                </div>

                {/* ==================================================
                    BODY
                   ================================================== */}
<div className="card-body">

{/* ==================================================
    FILTRE CONSULTATIONS
   ================================================== */}

<div className="consultation-filter mb-3">
    <div className="consultation-radio-group">
        <div className="form-check consultation-radio">
            <input
                className="form-check-input"
                type="radio"
                name="consultationFilter"
                id="filterAll"
                value="ALL"
                checked={consultationFilter === "ALL"}
                onChange={(e) => {
                    setPage(0);
                    setConsultationFilter(e.target.value);
                }}
            />

            <label
                className="form-check-label"
                htmlFor="filterAll"
            >
                 {t("consultationRequest.pageTitleAll")}
            </label>
        </div>


        <div className="form-check consultation-radio">
            <input
                className="form-check-input"
                type="radio"
                name="consultationFilter"
                id="filterReceived"
                value="RECEIVED"
                checked={consultationFilter === "RECEIVED"}
                onChange={(e) => {
                    setPage(0);
                    setConsultationFilter(e.target.value);
                }}
            />

            <label
                className="form-check-label"
                htmlFor="filterReceived"
            >
               {t("consultationRequest.pageTitleReceiver")}
            </label>
        </div>


        <div className="form-check consultation-radio">
            <input
                className="form-check-input"
                type="radio"
                name="consultationFilter"
                id="filterSent"
                value="SENT"
                checked={consultationFilter === "SENT"}
                onChange={(e) => {
                    setPage(0);
                    setConsultationFilter(e.target.value);
                }}
            />

            <label
                className="form-check-label"
                htmlFor="filterSent"
            >
                {t("consultationRequest.pageTitleSender")}
            </label>
        </div>

    </div>

</div>

    {/* ==================================================
        BARRE RECHERCHE
       ================================================== */}

    <ConsultationSearchBar
        keyword={keyword}
        onSearch={handleSearch}
        onAdd={handleAdd}
    />

    {/* ==================================================
        LISTE CONSULTATIONS
       ================================================== */}

    <ConsultationRequestList
        isAdmin={isAdmin}
        consultations={consultations}
        mode={consultationFilter}
        loading={loading}
        currentUser={loggedUser}
        onView={handleDetail}
        onEdit={handleEdit}
        onDelete={handleDelete}
    />

    <Pagination
        currentPage={page}
        totalPages={totalPages}
        onPageChange={setPage}
    />

</div>

            </div>


            {/* =====================================================
                FORMULAIRE
               ===================================================== */}

            {
                showForm && (

                    <div
                        className="
                            modal
                            fade
                            show
                            d-block
                        "
                        tabIndex="-1"
                    >

                        <div
                            className="
                                modal-dialog
                                modal-xl
                                modal-dialog-centered
                            "
                        >

                            <div className="modal-content">

                                <ConsultationRequestForm

                                    consultation={
                                        consultation
                                    }

                                    message={
                                        message
                                    }

                                    consultants={
                                        consultants
                                    }

                                    specialites={
                                        specialites
                                    }

                                    activityProfs={
                                        activityProfs
                                    }

                                    wilayas={
                                        wilayas
                                    }

                                    consultantFilters={
                                        consultantFilters
                                    }

                                    onFilterChange={
                                        handleConsultantFilterChange
                                    }

                                    onSearchConsultants={
                                        loadConsultants
                                    }

                                    errors={
                                        errors
                                    }

                                    loading={
                                        saving
                                    }

                                    onChange={
                                        handleChange
                                    }

                                    onSubmit={
                                        handleSubmit
                                    }

                                    onCancel={
                                        handleCancel
                                    }

                                />

                            </div>

                        </div>

                    </div>
                )
            }


            {/* =====================================================
                DETAIL
               ===================================================== */}

            {
                showDetail && (

                    <div
                        className="
                            modal
                            fade
                            show
                            d-block
                        "
                        tabIndex="-1"
                    >

                        <div
                            className="
                                modal-dialog
                                modal-xl
                                modal-dialog-centered
                            "
                        >

                            <div className="modal-content">

                                <ConsultationRequestDetail

                                    request={
                                        consultation
                                    }

                                    messages={
                                        messages
                                    }

                                    currentUser={
                                        loggedUser
                                    }

                                    reply={
                                        message
                                    }

                                    errors={
                                        errors
                                    }

                                    loading={
                                        saving
                                    }

                                    onReplyChange={
                                        handleChange
                                    }
                                    onReplySubmit={
                                        handleReply
                                    }

                                    onBack={() => {

                                        setShowDetail(
                                            false
                                        );

                                        setMessages([]);

                                        setErrors({});
                                    }}

                                    onEdit={
                                        handleEdit
                                    }

                                    onDelete={
                                        handleDelete
                                    }

                                    onDownloadFile={
                                        handleDownloadFile
                                    }

                                />

                            </div>

                        </div>

                    </div>
                )
            }


            {/* =====================================================
                BACKDROP
               ===================================================== */}

            {
                (showForm || showDetail) && (

                    <div
                        className="
                            modal-backdrop
                            fade
                            show
                        "
                    />

                )
            }


            {/* =====================================================
                MODAL CONFIRMATION SUPPRESSION
               ===================================================== */}

            <ConfirmationModal
                isOpen={
                    showConfirmationModal
                }

                onConfirm={
                    handleConfirmDelete
                }

                onCancel={
                    handleCloseModal
                }

            />

        </div>
    );
}